@if (isReady() && user(); as u) {
  <stripe-pricing-table
    [attr.pricing-table-id]="pricingTableId()"
    [attr.publishable-key]="publishableKey()"
    [attr.client-reference-id]="u._id"
    [attr.customer-email]="customerSessionClientSecret() ? null : u.contactInfos.email"
    [attr.customer-session-client-secret]="customerSessionClientSecret()"
  >
  </stripe-pricing-table>
} @else {
  <div class="flex flex-col items-center justify-center py-20 gap-4">
    <mat-spinner diameter="48" strokeWidth="4" class="primary"></mat-spinner>
    <span class="text-neutral-500 dark:text-neutral-400 font-medium animate-pulse">
      Chargement de votre espace de facturation...
    </span>
  </div>
}
